import axios from 'axios';
import { clearAuthData } from './auth';

/** Cliente do ms-api-reports (relatórios centralizados). Mesmo Bearer do ms-api-system. */
const reportsClient = axios.create({
    baseURL: import.meta.env.VITE_REPORTS_API_URL,
    headers: { 'Content-Type': 'application/json' },
});

reportsClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

reportsClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearAuthData();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default reportsClient;
